import './fareextra/style';
import FormStructure from './fareextra/form_structure';

export default FormStructure;